"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Disabling rule to avoid potential null == undefined issues
// tslint:disable:triple-equals
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        /** Definition of the function names used with calling between proxy and real InteractionHandlers. */
        var InteractionHandlerFunction;
        (function (InteractionHandlerFunction) {
            InteractionHandlerFunction["processInteractions"] = "processInteractions";
            InteractionHandlerFunction["detachFormForPopout"] = "detachFormForPopout";
            InteractionHandlerFunction["_prepFormForPopout"] = "_prepFormForPopout";
            InteractionHandlerFunction["reserializeForm"] = "reserializeForm";
        })(InteractionHandlerFunction = serverForm.InteractionHandlerFunction || (serverForm.InteractionHandlerFunction = {}));
        /**
         * Responsible for Handling interactions returned from the server and applying them to the local window.
         * Each window has an instance of an InteractionHandler for applying interactions.
         */
        var InteractionHandler = /** @class */ (function () {
            function InteractionHandler() {
                this.forms = {};
                this._updatedTask = new $dyn.PerformanceTask("updatingCompleted", true);
                this._modelInteractionsTask = new $dyn.PerformanceTask("modelInteractions", true);
                this._viewInteractionsTask = $dyn.debug.performance ? new $dyn.PerformanceTask("viewInteractions", true) : null;
                this._viewInteractionTask = $dyn.debug.performance ? new $dyn.PerformanceTask("viewInteraction", true) : null;
                this._openFormTask = $dyn.debug.performance ? new $dyn.PerformanceTask("openForm", true) : null;
                this._applyDeltaTask = $dyn.debug.performance ? new $dyn.PerformanceTask("applyDelta") : null;
                this._applyDeltaTaskByName = $dyn.debug.performance ? new $dyn.PerformanceTask("applyDelta.ByName") : null;
                this._applyCommandTask = $dyn.debug.performance ? new $dyn.PerformanceTask("applyCommand") : null;
                this._applyPropertyTask = $dyn.debug.performance ? new $dyn.PerformanceTask("applyProperty") : null;
                this._applyPropertiesTask = $dyn.debug.performance ? new $dyn.PerformanceTask("applyProperties") : null;
                this._applyPropertiesByNameTask = $dyn.debug.performance ? new $dyn.PerformanceTask("applyProperties.ByName") : null;
                this._applyChildrenDeltaTask = $dyn.debug.performance ? new $dyn.PerformanceTask("applyChildrenDelta") : null;
                this._parentChangedTask = $dyn.debug.performance ? new $dyn.PerformanceTask("parentChanged", true) : null;
                this._controlRoleFaultTask = $dyn.debug.performance ? new $dyn.PerformanceTask("controlRoleFault", true) : null;
                this._createControlTask = $dyn.debug.performance ? new $dyn.PerformanceTask("createControl") : null;
                this._createControlByNameTask = $dyn.debug.performance ? new $dyn.PerformanceTask("createControl.ByName") : null;
            }
            InteractionHandler.prototype.getFormElement = function (id) {
                var form = this.forms[id];
                if (!form) {
                    // Ideally forms should be registered with the interaction channel but some command that take a form id are not custom commands
                    // such as RequestPopup, CreateForm, etc.
                    form = document.getElementById("form_" + id);
                }
                return form;
            };
            InteractionHandler.prototype.getForm = function (options) {
                var getFormInteraction;
                var targetElement = options.targetElement;
                if (!targetElement) {
                    throw new Error("options.targetElement is required");
                }
                // If we're in a popout window but have no linked parent window, we should not try to get a form.
                if ($dyn.popout && !$dyn.parentWindow) {
                    $dyn.log.server && $dyn.log.server("Cannot get form in popout window if we have no link to parent window.");
                    return;
                }
                var formId = targetElement.getAttribute("data-dyn-formid");
                var openMethod;
                var objectName;
                if (options.menuItem) {
                    // menuItem may have a menu item type prefix in the format {type}:{name}
                    var miFragments = options.menuItem.split(":");
                    if (miFragments && miFragments.length === 2) {
                        objectName = miFragments[1].toLowerCase();
                        openMethod = $dyn.serverForm.FormOpenMethod.find(miFragments[0]);
                    }
                    else {
                        objectName = options.menuItem;
                    }
                    var controlOptions_1 = $dyn.controlOptions(targetElement);
                    if (!controlOptions_1) {
                        controlOptions_1 = targetElement.dynOptions = {};
                    }
                    $dyn.setValue(controlOptions_1, "MenuItemName", objectName);
                    // Display is the default open method
                    // $dyn.shell.getQueryStringForNewMenuItem depends on this default method.
                    openMethod = openMethod || $dyn.serverForm.FormOpenMethod.Display;
                }
                else {
                    objectName = options.name;
                    openMethod = $dyn.serverForm.FormOpenMethod.Form;
                }
                var pageType;
                if (options.pagetype) {
                    pageType = $dyn.serverForm.FormViewOption.find(options.pagetype);
                }
                if (targetElement) {
                    // Build a getFormInteractionObject
                    var shouldBlockOnExecution = options.ShouldBlockOnExecution == undefined ? true : options.ShouldBlockOnExecution;
                    getFormInteraction = {
                        $type: $dyn.serverForm.InteractionType.getForm,
                        ArgFilter: options.DataFilter,
                        // Include the navigation path without the last menu item part
                        NavigationPath: options.NavigationPath != null && options.NavigationPath.length > 1 ? options.NavigationPath.slice(0, options.NavigationPath.length - 1) : undefined,
                        ObjectName: objectName,
                        OpenMethod: openMethod,
                        PageType: pageType,
                        PartHostViewConfiguration: options.PartHostViewConfiguration,
                        RecordContext: options.recordcontext,
                        ShouldBlockOnExecution: shouldBlockOnExecution,
                        TargetId: formId,
                    };
                }
                else {
                    getFormInteraction = options;
                    getFormInteraction.$type = $dyn.serverForm.InteractionType.getForm;
                }
                this.forms[formId] = targetElement;
                if (!options.callback) {
                    options.callback = function (result) {
                        var openedForm = result > 0;
                        var form = $dyn.context(targetElement);
                        var isOpen = !!(form && $dyn.value(form.IsOpen));
                        if (openedForm !== isOpen) {
                            $dyn.log.server &&
                                $dyn.log.server.error("ServerForm: Unexpected form state after getForm interaction: %s, type: %s, openedForm: %s, isOpen: %s", objectName, openMethod, openedForm, isOpen);
                        }
                        if (!openedForm && !isOpen) {
                            if (result === -1) {
                                $dyn.log.server && $dyn.log.server("ServerForm: Removing form after unsuccessful getForm interaction: %s, type: %s", objectName, openMethod);
                            }
                            else {
                                $dyn.log.server && $dyn.log.server("ServerForm: No form return with getForm interaction: %s, type: %s", objectName, openMethod);
                            }
                            if (targetElement.parentNode) {
                                targetElement.parentNode.removeChild(targetElement);
                                $dyn.unbind(targetElement);
                            }
                        }
                    };
                }
                var channelOptions = {
                    channelType: $dyn.serverForm.InteractionChannelType.any,
                    formPart: options.formPart,
                };
                // If there is a callback, queue a callback command interaction
                if ($dyn.serverForm.compilation.StaticLoader.staticLoaderOn && options.name && !options.formPart) {
                    this.blockInbound(true);
                    getFormInteraction.PartialDelta = true;
                    $dyn.serverForm.interactionManager.queueCallbackCommandInteraction(getFormInteraction, options.callback, channelOptions, true);
                    $dyn.serverForm.compilation.StaticLoader.load(options.name, targetElement, formId, this);
                }
                else {
                    $dyn.serverForm.interactionManager.queueCallbackCommandInteraction(getFormInteraction, options.callback, channelOptions, true);
                }
            };
            InteractionHandler.prototype._prepFormForPopout = function (rootId) {
                $dyn.serverForm.saveTransitState(rootId);
            };
            InteractionHandler.prototype.detachFormForPopout = function (rootId) {
                var rootElement = this.getFormElement(rootId);
                var allControls = rootElement && rootElement.dynOptions && rootElement.dynOptions._allControls;
                rootElement.dynOptions._allControls = null;
                var rootControl = $dyn.context(rootElement);
                if (rootControl) {
                    $dyn.shell.browserHistory.goingBack = false;
                    rootControl.detachedForPopout = true;
                    $dyn.shell.close({ form: rootControl });
                }
                delete this.forms[rootId];
                $dyn.serverForm.ModelManager.removeFormModelsAndCollections(rootId);
                if (allControls) {
                    this._cleanupControls(allControls);
                }
                $dyn.serverForm._windowManager.notifyFormDetached(rootId);
                return true;
            };
            InteractionHandler.prototype.reserializeForm = function (rootId) {
                // This method is called to prep the DOM to reserialize root Forms.
                // Other things like PartForms have their own method of calling the reserialize command and setting up their targetElement with the approproate role.
                // Call shell's createForm to set up the DOM for the form that will get reserialized.
                var options = {
                    context: $dyn.serverForm.getModel(rootId),
                    id: rootId,
                    role: "Form",
                };
                var targetElement = $dyn.shell.createForm(options);
                // Enqueue interaction to server (through interactionManager) to reload the form.
                var commandInteraction = {
                    $type: $dyn.serverForm.InteractionType.command,
                    CommandName: "Reserialize",
                    ShouldBlockOnExecution: true,
                    TargetId: rootId,
                };
                var callback = function () {
                    $dyn.serverForm._windowManager.notifyFormReserialized(rootId);
                };
                var channelOptions = {
                    channelType: $dyn.serverForm.InteractionChannelType.byRootId,
                    rootId: rootId,
                };
                $dyn.serverForm.interactionManager.queueCallbackCommandInteraction(commandInteraction, callback, channelOptions, true);
            };
            /**
             * Gets the root ID by element for a server control
             * @param element The element
             * @returns The root ID for a server control; otherwise, `null` if the element does not represent a server control or form
             */
            InteractionHandler.prototype.getRootIdByElement = function (element) {
                return element.getAttribute("data-dyn-rootserverid");
            };
            /**
             * Handler that listens for postMessage events and reacts accordingly if it is for the desired class
             * @remarks All PostMessage event handlers should ensure the following:
             * 1. The `event.origin` is from the same location
             * 2. The `event.data` is of the type we are expecting
             * 3. The data contains some sort of unique identifier which our handler knows to look for and will not process if not found.
             * @param event The message to handle
             */
            InteractionHandler.prototype.handleMessages = function (event) {
                if (event.origin !== $dyn.util.getOrigin($dyn.util.location.location)) {
                    // Do not allow communication if it is cross origin.
                    return;
                }
                var data = event.data;
                // Sanity check. Ensure these are coming for the InteractionHandler
                if (typeof data === "object" && data.source === "InteractionHandler") {
                    switch (data.commandName) {
                        case $dyn.serverForm.InteractionHandlerFunction.processInteractions:
                            $dyn.serverForm.interactionHandler.processInteractions(data.interactions);
                            break;
                        case $dyn.serverForm.InteractionHandlerFunction.detachFormForPopout:
                            $dyn.serverForm.interactionHandler.detachFormForPopout(data.rootId);
                            break;
                        case $dyn.serverForm.InteractionHandlerFunction._prepFormForPopout:
                            $dyn.serverForm.interactionHandler._prepFormForPopout(data.rootId);
                            break;
                        case $dyn.serverForm.InteractionHandlerFunction.reserializeForm:
                            $dyn.serverForm.interactionHandler.reserializeForm(data.rootId);
                            break;
                        default:
                            break;
                    }
                }
                if (data.source === "callback") {
                    if (typeof $dyn.serverForm.idToWindowFunction[data._functionId] === "function") {
                        $dyn.serverForm.idToWindowFunction[data._functionId](data._result);
                        $dyn.log.server && $dyn.log.server("InteractionHandler: Calling function with functionId: " + data._functionId);
                    }
                    else {
                        $dyn.log.server && $dyn.log.server("InteractionHandler: Cannot call window function with functionId: " + data._functionId + " as it does not exist in the mapping.");
                    }
                    $dyn.serverForm.idToWindowFunction[data._functionId] = null;
                }
            };
            /**
             * Processes the given set of interactions
             * @param interactions The interactions to be handled
             * @param ignoreBlock Set to `true` by static loading to prevent interactions being edded to pending
             */
            InteractionHandler.prototype.processInteractions = function (interactions, ignoreBlock) {
                if (!ignoreBlock && this._inboundBlocked === true) {
                    if (this._penndingInboundInteractions == null) {
                        this._penndingInboundInteractions = [];
                    }
                    this._penndingInboundInteractions.push.apply(this._penndingInboundInteractions, interactions);
                    return;
                }
                $dyn.ui.updating(true);
                $dyn.ui.layout(true);
                this.processingInteractions = true;
                // Separate the interactions into the model/view-model/view categories
                var updateIdInteractions = [];
                var clientMessageLogInteractions = [];
                var modelInteractions = [];
                var viewInteractions = [];
                var viewBeforeModelInteractions = [];
                var commandCallbackInteractions = [];
                var partFormsGoingToCache = {};
                var tempPartFormCache = {};
                var headedToPartFormCache = function (_interaction) {
                    return !!partFormsGoingToCache[_interaction.RootId];
                };
                var interaction;
                // Do initial sweep to find all part forms and their rootId's that need to go to cache
                for (var i = 0, len = interactions.length; i < len; i++) {
                    interaction = interactions[i];
                    if (interaction.Descriptor &&
                        interaction.Descriptor.ValueProperties &&
                        interaction.Descriptor.ValueProperties.InlineLoadingKey &&
                        !interaction.skipCache) {
                        // Check if the DOM is ready to accept the descriptor for this partform. If so, then it doesn't need to go to cache, but can be applied now.
                        var formId = interaction.RootId;
                        var formElement = $dyn.serverForm.interactionHandler.getFormElement(formId);
                        if (!formElement) {
                            var key = interaction.Descriptor.ValueProperties.InlineLoadingKey;
                            partFormsGoingToCache[formId] = key; // Mark this root_id as in cache, reserving the InlineLoadingKey for later use by the interactions
                        }
                    }
                }
                // array
                for (var i = 0, len = interactions.length; i < len; i++) {
                    interaction = interactions[i];
                    if (headedToPartFormCache(interaction)) {
                        // This catches descriptors with rootId's that need to go into the cache
                        var key = partFormsGoingToCache[interaction.RootId];
                        interaction.skipCache = true; // Ensures the interaction only goes into the cache once and doesn't get caught the second time when it is actually applied.
                        // Place in special Queue
                        if (!tempPartFormCache[key]) {
                            tempPartFormCache[key] = [];
                        }
                        tempPartFormCache[key].push(interaction); // Collect all interactions relating to PartForm for later application.
                        continue;
                    }
                    switch (interaction.$type) {
                        case $dyn.serverForm.InteractionType.createModel:
                        case $dyn.serverForm.InteractionType.updateModel:
                        case $dyn.serverForm.InteractionType.updateModelCollection:
                            if (interaction.RootId === "ClientMessageLog") {
                                clientMessageLogInteractions.push(interaction);
                            }
                            else {
                                modelInteractions.push(interaction);
                            }
                            break;
                        case $dyn.serverForm.InteractionType.changeViewModelId:
                            updateIdInteractions.push(interaction);
                            break;
                        case $dyn.serverForm.InteractionType.createViewModel:
                        case $dyn.serverForm.InteractionType.updateViewModel:
                        case $dyn.serverForm.InteractionType.deleteViewModel:
                            if (interaction.Descriptor && interaction.Descriptor.Name === "ClientUserSession") {
                                viewBeforeModelInteractions.push(interaction);
                            }
                            else {
                                viewInteractions.push(interaction);
                            }
                            break;
                        case $dyn.serverForm.InteractionType.setLookupValue:
                            viewBeforeModelInteractions.push(interaction);
                            break;
                        case $dyn.serverForm.InteractionType.commandCallback:
                            commandCallbackInteractions.push(interaction);
                            break;
                        case $dyn.serverForm.InteractionType.navigate:
                            $dyn.shell.navigateUrl(interaction.NamedParameters);
                            break;
                    }
                }
                // Insert partForm interactions into the part form cache and raise and event if there were any
                var shouldRaise = false;
                // tslint:disable-next-line:forin
                for (var key in tempPartFormCache) {
                    $dyn.serverForm.cachedPartFormInteractions[key] = tempPartFormCache[key];
                    shouldRaise = true;
                }
                shouldRaise && $dyn.serverForm.partFormCacheUpdated.raise();
                // Now handle the three sets of interactions: first changing ids, then model, then view-model, and then command callbacks
                this._handleChangeId(updateIdInteractions);
                // Handle any infolog messages first
                this._handleFormDeleteMessages(viewInteractions, clientMessageLogInteractions);
                modelInteractions = clientMessageLogInteractions.concat(modelInteractions);
                $dyn.serverForm.ModelManager._updateVersion();
                this._handleViewInteractions(viewBeforeModelInteractions);
                this._handleModelInteractions(modelInteractions);
                this._handleViewInteractions(viewInteractions);
                this._handleCommandCallbacks(commandCallbackInteractions);
                if ($dyn.serverForm.ModelManager.insertedRecordsAbove) {
                    if ($dyn.serverForm.ModelManager.loadDirection === $dyn.ui.ScrollDirection.none) {
                        // We might have inserted records above the current scroll position
                        // Need to set the direction to up so the ReactGrid can handle that
                        $dyn.serverForm.ModelManager.loadDirection = $dyn.ui.ScrollDirection.up;
                        // reset scroll direction thru data cache for this form if there is render pending
                        var calledReset = false;
                        if ($dyn.DataCacheManager[$dyn.serverForm.ModelManager.activeRootId]) {
                            for (var dsName in $dyn.DataCacheManager[$dyn.serverForm.ModelManager.activeRootId]) {
                                if ($dyn.DataCacheManager[$dyn.serverForm.ModelManager.activeRootId][dsName]) {
                                    for (var dataCacheName in $dyn.DataCacheManager[$dyn.serverForm.ModelManager.activeRootId][dsName]) {
                                        if ($dyn.DataCacheManager[$dyn.serverForm.ModelManager.activeRootId][dsName][dataCacheName]) {
                                            var dataCache = $dyn.DataCacheManager[$dyn.serverForm.ModelManager.activeRootId][dsName][dataCacheName];
                                            if (dataCache.hasRenderCallPending()) {
                                                dataCache.resetLoadDirection();
                                                calledReset = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        // if we didnt call reset then no data cache has a render pending so we can just reset once on the model manager
                        if (!calledReset) {
                            $dyn.serverForm.ModelManager.loadDirection = $dyn.ui.ScrollDirection.none;
                        }
                    }
                    // Clear flags
                    $dyn.serverForm.ModelManager.insertedRecordsAbove = false;
                    $dyn.serverForm.ModelManager.activeRootId = "";
                }
                this.processingInteractions = false;
                this._updatedTask && this._updatedTask.start();
                $dyn.ui.updating(false);
                this._updatedTask && this._updatedTask.stop();
                $dyn.ui.layout(false);
            };
            /** Gets or sets whether inbound interactions from server to remain blocked or not */
            InteractionHandler.prototype.blockInbound = function (value) {
                if (value !== undefined && this._inboundBlocked !== value) {
                    this._inboundBlocked = value;
                    if (!this._inboundBlocked && this._penndingInboundInteractions && this._penndingInboundInteractions.length > 0) {
                        this.processInteractions(this._penndingInboundInteractions);
                        this._penndingInboundInteractions = null;
                    }
                }
                return this._inboundBlocked;
            };
            InteractionHandler.prototype.closeFormByRootId = function (rootId) {
                var rootElement = this.getFormElement(rootId);
                if (rootElement) {
                    // deleteViewModel is the result of a RequestClose() call to the server.  This triggers the 3rd step of the form.Close process.
                    // The assumption above may not be always, delete might have come completely from a server operation
                    // Check the display-target since we handle forms with different targets differently
                    this._closeForm(rootElement);
                }
                delete this.forms[rootId];
                if ($dyn.DataCacheManager[rootId]) {
                    delete $dyn.DataCacheManager[rootId];
                }
                if ($dyn.GroupInfoManager[rootId]) {
                    delete $dyn.GroupInfoManager[rootId];
                }
                $dyn.serverForm.ModelManager.removeFormModelsAndCollections(rootId);
                if ($dyn.serverForm.interactionManager && $dyn.serverForm.interactionManager.updateMapOnFormDelete) {
                    $dyn.serverForm.interactionManager.updateMapOnFormDelete(rootId);
                }
            };
            // TODO: Use controlParams instead of dom element, options, and descriptor
            InteractionHandler.prototype._cloneProperties = function (targetElement, sourceOptions, controlRole) {
                var parentDataSource = controlRole._dataSourceContext.current;
                var options = Object.create(sourceOptions);
                if (parentDataSource && parentDataSource.DataSource instanceof $dyn.serverForm.Model) {
                    // Redirect to the contained model if "parentDataSource" is a control.
                    parentDataSource = options.DataSource = parentDataSource.DataSource;
                }
                else {
                    options.DataSource = parentDataSource;
                }
                var list = controlRole.context.scopeVars.$list;
                var rootElement = list.Root.element;
                var controlName = sourceOptions._name;
                var virtualProperties = sourceOptions._descriptor.virtualProperties;
                sourceOptions._descriptor.virtualizedPropertyChanged.subscribe(function (changes) {
                    if (changes && Object.keys(changes).length > 0) {
                        $dyn.log.server && $dyn.log.server("ServerForm: List schema changed: %s - %o", list.Name, changes);
                        list.updateSchema();
                    }
                });
                // tslint:disable-next-line:forin
                for (var name_1 in virtualProperties) {
                    var virtualizer = virtualProperties[name_1];
                    virtualizer = virtualizer || $dyn.serverForm.getVirtualValue;
                    options[name_1] = virtualizer(controlName, name_1, parentDataSource, rootElement);
                    $dyn.serverForm.subscribeToVirtualizedPropertyChange(controlName, name_1, rootElement, list.dataChanged);
                }
                var referenceProperties = sourceOptions._descriptor.referenceProperties;
                sourceOptions._descriptor.referencePropertyChanged.subscribe(function (changes) {
                    if (changes && changes.length > 0) {
                        $dyn.log.server && $dyn.log.server("ServerForm: List schema changed: %s - %o", list.Name, changes);
                        list.updateSchema();
                    }
                });
                var _loop_1 = function (name_2) {
                    // Reference properties are not cloned.
                    var property = referenceProperties[name_2];
                    // Ensure that the property is observable.
                    var observableProp = (options[name_2] = $dyn.observable());
                    var modelName = (observableProp.__ModelName = $dyn.serverForm.getCollectionName(property.ModelName));
                    var modelFieldName = (observableProp.__ModelFieldName = $dyn.serverForm.getPropertyName(property.ModelFieldName));
                    var model = $dyn.getModel(modelName, parentDataSource);
                    if (model) {
                        var boundProp = $dyn.getFieldObservable(modelFieldName, model);
                        $dyn.oneWayBinding(boundProp, observableProp);
                    }
                    // If control is bound to form model field , we need to observe Model level changes instead of
                    // ModelCollection level changes. (Form Model does not have a parent ModelCollection or masterdatasource.)
                    if (property.ModelName === list.Root.DataSource.collectionName) {
                        list.Root.DataSource.propertyChanged().subscribe(list.rerender);
                    }
                    else {
                        var _modelCollection_1 = list.Root.DataSource.getRelatedCollection(modelName);
                        // masterdatasource for a model collection will be sent by server and can be populated at a later time.
                        // If the column is bound to a DS that does not have grid as its master DS , we need to do full rerender.
                        // this will be true for non inner/outer joined DS to the grid's DS
                        if ($dyn.value(_modelCollection_1.masterDataSourceName) == undefined) {
                            var subscriberId_1 = _modelCollection_1.masterDataSourceName.valueChanged.subscribe(function (_modelCollectionName) {
                                if (_modelCollectionName !== undefined && list.DataSource) {
                                    var masterDSName = $dyn.serverForm.getCollectionName($dyn.value(_modelCollectionName));
                                    // If the column is bound to a DS that does not have grid as its master DS, we need to do full rerender.
                                    // we use __boundDataSource property which is set during the applyDelta phase. __boundDataSource referes to the
                                    // modelcollection object.
                                    if (list.DataSource.__boundDataSource && masterDSName === list.DataSource.__boundDataSource.name) {
                                        _modelCollection_1.itemsChanged().subscribe(list.dataChanged);
                                    }
                                    else {
                                        _modelCollection_1.itemsChanged().subscribe(list.rerender);
                                    }
                                    _modelCollection_1.masterDataSourceName.valueChanged.unsubscribe(subscriberId_1);
                                }
                            });
                        }
                        else {
                            var masterDSName = $dyn.serverForm.getCollectionName($dyn.value(_modelCollection_1.masterDataSourceName));
                            // If the column is bound to a DS that does not have grid as its master DS , we need to do full rerender.
                            // we use __boundDataSource property which is set during the applyDelta phase. __boundDataSource referes to the
                            // modelcollection object
                            if (list.DataSource.__boundDataSource && masterDSName === list.DataSource.__boundDataSource.name) {
                                _modelCollection_1.itemsChanged().subscribe(list.dataChanged);
                            }
                            else {
                                _modelCollection_1.itemsChanged().subscribe(list.rerender);
                            }
                        }
                    }
                };
                // tslint:disable-next-line:forin
                for (var name_2 in referenceProperties) {
                    _loop_1(name_2);
                }
                return options;
            };
            InteractionHandler.prototype.clone = function (controlRole) {
                var root = controlRole.root;
                if (!root) {
                    return;
                }
                var rootElement = root.element;
                if (rootElement) {
                    // Ideally should not need to access the dom to get the name.
                    var controlName = controlRole.targetElement.getAttribute("data-dyn-controlname");
                    // The elements represent the source element which is being cloned
                    var sourceElement = $dyn.serverForm.getElement(controlName, rootElement.dynOptions);
                    if (sourceElement) {
                        return this._cloneProperties(controlRole.targetElement, sourceElement.dynOptions, controlRole);
                    }
                }
                else {
                    // This is informational as this can happen when a control has no parameters but is not a server form control.
                    // Ideally this should be an error but there is currently a server form dependency in controls.js
                    $dyn.log.server && $dyn.log.server("ServerForm: Root not found: element: %o", controlRole.targetElement);
                }
            };
            InteractionHandler.prototype._handleChangeId = function (interactions) {
                for (var i = 0, len = interactions.length; i < len; i++) {
                    var interaction = interactions[i];
                    var form = this.getFormElement(interaction.PreviousValue);
                    this.forms[interaction.NewValue] = form;
                    delete this.forms[interaction.PreviousValue];
                    var formControl = $dyn.context(form);
                    if (formControl) {
                        // Form is data bound -- update through the control object
                        formControl.Id = interaction.NewValue;
                    }
                    else if (form) {
                        // form element exists but isn't data-bound yet
                        form.setAttribute("id", "form_" + interaction.NewValue);
                        form.setAttribute("data-dyn-formid", interaction.NewValue);
                    }
                    else {
                        $dyn.logError("Shell: Cannot update formId=%s: no such form element", interaction.PreviousValue);
                        return;
                    }
                    var model = $dyn.serverForm.ModelManager.getModel(interaction.PreviousValue);
                    delete $dyn.serverForm.ModelManager.models[interaction.PreviousValue];
                    model.id = interaction.NewValue;
                    $dyn.serverForm.ModelManager.trackModel(model, interaction.NewValue);
                    if (model.parent && model.parent.UseReactGrid) {
                        if ($dyn.DataCacheManager[interaction.PreviousValue]) {
                            $dyn.DataCacheManager[interaction.NewValue] = $dyn.DataCacheManager[interaction.PreviousValue];
                            delete $dyn.DataCacheManager[interaction.PreviousValue];
                        }
                        if ($dyn.GroupInfoManager[interaction.PreviousValue]) {
                            $dyn.GroupInfoManager[interaction.NewValue] = $dyn.GroupInfoManager[interaction.PreviousValue];
                            delete $dyn.GroupInfoManager[interaction.PreviousValue];
                        }
                    }
                }
            };
            InteractionHandler.prototype._handleModelInteractions = function (interactions) {
                var e_1, _a, e_2, _b, e_3, _c;
                this._modelInteractionsTask && this._modelInteractionsTask.start();
                var updateModelCollectionInteractionsToDeserialize = [];
                var createModelInteractionsToDeserialize = [];
                var updateModelInteractionsToDeserialize = {};
                try {
                    for (var interactions_1 = __values(interactions), interactions_1_1 = interactions_1.next(); !interactions_1_1.done; interactions_1_1 = interactions_1.next()) {
                        var interaction = interactions_1_1.value;
                        if (interaction.$type === $dyn.serverForm.InteractionType.createModel) {
                            createModelInteractionsToDeserialize.push(interaction);
                        }
                        else if (interaction.$type === $dyn.serverForm.InteractionType.updateModel) {
                            var interactableId = interaction.Descriptor.Id;
                            if (!updateModelInteractionsToDeserialize[interactableId]) {
                                updateModelInteractionsToDeserialize[interactableId] = interaction;
                            }
                            else {
                                // Multiple update models for same interactable id
                                // Merge it in, with the last one getting precedence on conflicts
                                $dyn.logWarning("Multiple updates for single model");
                                if (interaction.Descriptor.Properties) {
                                    // tslint:disable-next-line:forin
                                    for (var propertyName in interaction.Descriptor.Properties) {
                                        updateModelInteractionsToDeserialize[interactableId].Descriptor.Properties[propertyName] = interaction.Descriptor.Properties[propertyName];
                                    }
                                }
                            }
                        }
                        else if (interaction.$type === $dyn.serverForm.InteractionType.updateModelCollection) {
                            updateModelCollectionInteractionsToDeserialize.push(interaction);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (interactions_1_1 && !interactions_1_1.done && (_a = interactions_1.return)) _a.call(interactions_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                try {
                    // Create model should be for the form model creating the model collections, which needs to be done before any updateModelCollection
                    // interactions can be deserialized
                    for (var createModelInteractionsToDeserialize_1 = __values(createModelInteractionsToDeserialize), createModelInteractionsToDeserialize_1_1 = createModelInteractionsToDeserialize_1.next(); !createModelInteractionsToDeserialize_1_1.done; createModelInteractionsToDeserialize_1_1 = createModelInteractionsToDeserialize_1.next()) {
                        var createModelInteraction = createModelInteractionsToDeserialize_1_1.value;
                        var formId = createModelInteraction.RootId;
                        $dyn.log.server && $dyn.log.server("ServerForm: Adding record: %s, datasource: %s", createModelInteraction.Descriptor.Id, createModelInteraction.Descriptor.Name);
                        this._handleUpdateModelInteraction(createModelInteraction, formId);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (createModelInteractionsToDeserialize_1_1 && !createModelInteractionsToDeserialize_1_1.done && (_b = createModelInteractionsToDeserialize_1.return)) _b.call(createModelInteractionsToDeserialize_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                try {
                    // Deserialize models after model collections as model deserialization has dependency on collection index
                    // that can be changed while deserializing model collection (Marking depends on collection index as an example)
                    for (var updateModelCollectionInteractionsToDeserialize_1 = __values(updateModelCollectionInteractionsToDeserialize), updateModelCollectionInteractionsToDeserialize_1_1 = updateModelCollectionInteractionsToDeserialize_1.next(); !updateModelCollectionInteractionsToDeserialize_1_1.done; updateModelCollectionInteractionsToDeserialize_1_1 = updateModelCollectionInteractionsToDeserialize_1.next()) {
                        var updateCollectionInteraction = updateModelCollectionInteractionsToDeserialize_1_1.value;
                        $dyn.log.server && $dyn.log.server("ServerForm: Updating data source: %s", updateCollectionInteraction.Descriptor.Name);
                        var root = $dyn.serverForm.ModelManager.getModel(updateCollectionInteraction.RootId);
                        if (root) {
                            if (updateCollectionInteraction.Descriptor && updateCollectionInteraction.Descriptor.Name) {
                                var formId = root._formId;
                                var collection = root.getRelatedCollection($dyn.serverForm.getCollectionName(updateCollectionInteraction.Descriptor.Name));
                                if (collection.UseReactGrid) {
                                    collection.mergeModelUpdates(updateCollectionInteraction.Descriptor, updateModelInteractionsToDeserialize);
                                }
                                collection.deserialize(updateCollectionInteraction.Descriptor, formId);
                            }
                        }
                        else {
                            $dyn.logError("ServerForm: Failed to find model for rootId=%s", updateCollectionInteraction.RootId);
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (updateModelCollectionInteractionsToDeserialize_1_1 && !updateModelCollectionInteractionsToDeserialize_1_1.done && (_c = updateModelCollectionInteractionsToDeserialize_1.return)) _c.call(updateModelCollectionInteractionsToDeserialize_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                var updateModelInteractionsIds = Object.keys(updateModelInteractionsToDeserialize);
                for (var i = 0, len = updateModelInteractionsIds.length; i < len; i++) {
                    var updateModelInteraction = updateModelInteractionsToDeserialize[updateModelInteractionsIds[i]];
                    $dyn.log.server && $dyn.log.server("ServerForm: Updating record: %s", updateModelInteraction.Descriptor.Id);
                    this._handleUpdateModelInteraction(updateModelInteraction);
                }
                this._modelInteractionsTask && this._modelInteractionsTask.stop();
                $dyn.serverForm.UpdateModelManager.raiseChanges();
            };
            InteractionHandler.prototype._handleUpdateModelInteraction = function (interaction, formId) {
                var modelId = interaction.Descriptor.Id;
                if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName)) {
                    var masterTrackingId = interaction.Descriptor.Properties.MasterTrackingId;
                    var dataSourceName = interaction.Descriptor.Properties.dataSourceName_internal;
                    if (masterTrackingId && dataSourceName && interaction.RootId) {
                        var rootModel = $dyn.serverForm.ModelManager.getModel(interaction.RootId);
                        if (rootModel && rootModel.getValue("UseReactGrid")) {
                            if (dataSourceName.lastIndexOf("_ds") > 0) {
                                dataSourceName = dataSourceName.substring(0, dataSourceName.lastIndexOf("_ds"));
                            }
                            modelId = dataSourceName + "_" + masterTrackingId;
                        }
                    }
                    else {
                        var isForm = interaction.Descriptor.Name && interaction.Descriptor.Name.lastIndexOf("_form") > 0;
                        if (!isForm) {
                            // Methods on forms are expected not have a master tracking id
                            $dyn.log.reactList && $dyn.log.reactList("updateModel with no mastertrackingid: " + interaction.Descriptor.Id);
                        }
                    }
                }
                var model = $dyn.serverForm.ModelManager.getModel(modelId);
                if (!model) {
                    model = new $dyn.serverForm.Model();
                }
                else if (!formId) {
                    formId = model._formId;
                }
                model.deserialize(interaction.Descriptor, formId);
            };
            InteractionHandler.prototype._handleFormDeleteMessages = function (interactions, clientMessageLogInteractions) {
                var e_4, _a, e_5, _b;
                // if we have messages check the interactions for deletes
                // we need to clear out the form data on the messages that are for the form that is being deleted
                var firstClientMessageLogInteraction = clientMessageLogInteractions[0];
                if (firstClientMessageLogInteraction && firstClientMessageLogInteraction.Descriptor && firstClientMessageLogInteraction.Descriptor.Items && interactions) {
                    try {
                        for (var interactions_2 = __values(interactions), interactions_2_1 = interactions_2.next(); !interactions_2_1.done; interactions_2_1 = interactions_2.next()) {
                            var interaction = interactions_2_1.value;
                            // if we have a form delete
                            if (interaction.$type === $dyn.serverForm.InteractionType.deleteViewModel) {
                                var formToBeDeleted = void 0;
                                var rootElement_1 = this.getFormElement(interaction.RootId);
                                if (rootElement_1) {
                                    formToBeDeleted = $dyn.context(rootElement_1);
                                }
                                try {
                                    for (var _c = (e_5 = void 0, __values(firstClientMessageLogInteraction.Descriptor.Items)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                        var message = _d.value;
                                        // if we have a message that was for the form that is being deleted
                                        if (message.Item.Properties.formUniqueId == interaction.RootId ||
                                            (formToBeDeleted && formToBeDeleted.containsPartForm(message.Item.Properties.formUniqueId))) {
                                            message.Item.Properties.formContext = "";
                                            message.Item.Properties.formName = "";
                                            message.Item.Properties.formUniqueId = "";
                                        }
                                        // if we have a message with a parent id for the form that is being deleted clear the id so it will go to message center
                                        if (message.Item.Properties.parentFormUniqueId == interaction.RootId) {
                                            message.Item.Properties.parentFormUniqueId = "";
                                        }
                                    }
                                }
                                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                finally {
                                    try {
                                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                    }
                                    finally { if (e_5) throw e_5.error; }
                                }
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (interactions_2_1 && !interactions_2_1.done && (_a = interactions_2.return)) _a.call(interactions_2);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            };
            InteractionHandler.prototype._handleViewInteractions = function (interactions) {
                var e_6, _a;
                this._viewInteractionsTask && this._viewInteractionsTask.start();
                if (interactions.length > 0) {
                    var rootElement_2;
                    for (var i = 0, len = interactions.length; i < len; i++) {
                        var interaction = interactions[i];
                        var rootVisible = true;
                        // Use the name as the details if available
                        this._viewInteractionTask &&
                            this._viewInteractionTask.start(interaction.Descriptor && interaction.Descriptor.Name);
                        if (interaction.$type === $dyn.serverForm.InteractionType.createViewModel || interaction.$type === $dyn.serverForm.InteractionType.updateViewModel) {
                            var descriptor = interaction.Descriptor; // Top level descriptor (Form) // FormInTabPageControl1
                            this._fixDescriptor(descriptor);
                            if (interaction.Descriptor.Name === "ClientUserSession") {
                                rootElement_2 = $dyn.user().element;
                                if ($dyn.value(rootElement_2.dynReadyState) !== $dyn.ui.ReadyState.ready) {
                                    $dyn.user().MaxWaitTimeToFailInMinutes.valueChanged.subscribe($dyn.serverForm.setMaxWaitTimeToFailInMinutes);
                                    $dyn.user().WebClientStatefulSessionTimeoutInSeconds.valueChanged.subscribe($dyn.serverForm.setWebClientStatefulSessionTimeoutInSeconds);
                                }
                                $dyn.setObservableValue(rootElement_2, "dynReadyState", $dyn.ui.ReadyState.ready);
                                if (interaction.Descriptor.SerializedValueProperties && interaction.Descriptor.SerializedValueProperties.AosDraining) {
                                    $dyn.serverForm.aosDraining = $dyn.util.stringToBoolean(interaction.Descriptor.SerializedValueProperties.AosDraining);
                                }
                            }
                            else if (interaction.RootId == descriptor.Id) {
                                rootElement_2 = this.getFormElement(descriptor.Id);
                                var currentRole = rootElement_2 && rootElement_2.getAttribute("data-dyn-role");
                                if (currentRole !== descriptor.TypeName &&
                                    currentRole &&
                                    descriptor.TypeName &&
                                    (rootElement_2.dynReadyState() === "loading" || rootElement_2.dynReadyState() === "request" || rootElement_2.dynReadyState() === "uninitialized") &&
                                    !rootElement_2.hasAttribute("data-dyn-childform")) {
                                    // Only forms that are not child form can change their type (such as Dialogs but not FactBoxform)
                                    $dyn.logError("ServerForm: Form role changed: old - %s, new - %s", currentRole, descriptor.TypeName);
                                    this._closeForm(rootElement_2);
                                    rootElement_2 = null;
                                }
                                if (!rootElement_2) {
                                    var rootDataSource = $dyn.serverForm.getModel(descriptor.Id);
                                    rootElement_2 = this.forms[descriptor.Id] = $dyn.shell.createForm({
                                        context: rootDataSource,
                                        id: descriptor.Id,
                                        name: this._getFormName(descriptor),
                                        role: descriptor.TypeName,
                                    });
                                    // Check if the created form has an anchor control it attaches to.
                                    if (descriptor.ValueProperties) {
                                        var anchorRootId = descriptor.ValueProperties.anchorRootId;
                                        if (anchorRootId) {
                                            var anchorRootElement = this.getFormElement(anchorRootId);
                                            var anchorContext = $dyn.ui.findControl(descriptor.ValueProperties.anchorId, anchorRootElement);
                                            if (anchorContext) {
                                                // Only call this for react grids, since the popup observable is not set yet
                                                // This will then call $dyn.ui.popupHost.apply() to set the Popup observable so popup displays correctly
                                                if (anchorContext.isInGrid && anchorContext.isInGrid() && anchorContext.Root && anchorContext.Root.UseReactGrid()) {
                                                    $dyn.reactGrid.requestPopupOptions(anchorContext);
                                                }
                                                // All anchors should implement popupHost which provides the below properties.
                                                if (anchorContext.Popup) {
                                                    var $rootElement = $(rootElement_2);
                                                    anchorContext.Popup($rootElement);
                                                    // if the flyout is attached to a element that is not visible
                                                    // -do not show it
                                                    // -set the root as not visible so we don't have the shell open it
                                                    if ($dyn.value(anchorContext.Visible)) {
                                                        if (anchorContext.TypeName === "MultilineInput") {
                                                            var multilineInputContext = anchorContext;
                                                            if (!multilineInputContext.ShowLookupButton()) {
                                                                // Can be deleted when CLIMultiLineLookupFeature is mandatory
                                                                // This is still needed if lookup is not modeled correctly and they are opening lookup from x++ on a different button click
                                                                var flyoutOptions = {
                                                                    flyout: $rootElement,
                                                                    highlyResponsive: true,
                                                                    of: multilineInputContext.$inputElement,
                                                                    positionResize: true,
                                                                    requestPopup: anchorContext.showPopup,
                                                                    routeMessagesToParent: true,
                                                                    show: multilineInputContext.ShowFlyout,
                                                                };
                                                                $dyn.util.flyout(flyoutOptions, false);
                                                                // These observers get cleaned up in the flyout binding handler dispose, but since we don't have that here
                                                                // clean up the previous flyout's disposables and set value on control that it will clean up in its' dispose
                                                                if (multilineInputContext.flyoutDisposables) {
                                                                    try {
                                                                        for (var _b = (e_6 = void 0, __values(multilineInputContext.flyoutDisposables)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                                                            var disposable = _c.value;
                                                                            disposable.dispose();
                                                                        }
                                                                    }
                                                                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                                                    finally {
                                                                        try {
                                                                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                                                        }
                                                                        finally { if (e_6) throw e_6.error; }
                                                                    }
                                                                }
                                                                multilineInputContext.flyoutDisposables = [flyoutOptions.showSubscriber, flyoutOptions.activeFlyoutSubscriber];
                                                            }
                                                        }
                                                        anchorContext.ShowFlyout(true);
                                                    }
                                                    else {
                                                        $dyn.log.server && $dyn.log.server("Serverform: a flyout was requested when it's anchor was not visible");
                                                        rootVisible = false;
                                                    }
                                                }
                                                else {
                                                    $dyn.logError("anchorContext does not have a Popup");
                                                }
                                            }
                                        }
                                    }
                                    if (rootElement_2.dynReadyState) {
                                        if (rootElement_2.dynReadyState() !== $dyn.ui.ReadyState.aborted) {
                                            rootElement_2.dynReadyState($dyn.ui.ReadyState.loading);
                                        }
                                    }
                                    else {
                                        rootElement_2.dynReadyState = $dyn.observable($dyn.ui.ReadyState.loading);
                                    }
                                }
                                if (!rootElement_2.getAttribute("data-dyn-role")) {
                                    // createForm does not databind the form if the role is not set
                                    rootElement_2.setAttribute("data-dyn-role", descriptor.TypeName);
                                    var model = $dyn.serverForm.ModelManager.getModel(rootElement_2.getAttribute("data-dyn-formid"));
                                    $dyn.dataBind(rootElement_2, new $dyn.DataContext(model));
                                    // When createForm is called from navPane or search navigation then we do not have role defined
                                    // Hence below code needs to be called now which was not called in createForm because it had no role at that point
                                    var context_1 = $dyn.context(rootElement_2);
                                    if (context_1 && context_1.OnClientFormLoaded) {
                                        // call a function on the form signaling the loading on the client completed
                                        context_1.OnClientFormLoaded();
                                    }
                                }
                            }
                            else {
                                rootElement_2 = this.getFormElement(interaction.RootId);
                            }
                            if (rootElement_2) {
                                if (interaction.RootId == descriptor.Id && rootElement_2.dynReadyState() !== $dyn.ui.ReadyState.ready && rootElement_2.dynReadyState() !== $dyn.ui.ReadyState.preloading) {
                                    // Only first time
                                    rootElement_2.dynPerformance.requestEnd = window.performance.now();
                                    rootElement_2.dynPerformance.requestTime = rootElement_2.dynPerformance.requestEnd - rootElement_2.dynPerformance.requestStart;
                                    if (rootElement_2.dynReadyState() !== $dyn.ui.ReadyState.aborted) {
                                        rootElement_2.dynReadyState($dyn.ui.ReadyState.loading);
                                    }
                                    rootElement_2.dynPerformance.loadingStart = window.performance.now();
                                    // Set server Id attributes to form element
                                    rootElement_2.setAttribute("data-dyn-serverid", descriptor.Id);
                                    rootElement_2.setAttribute("data-dyn-rootserverid", descriptor.Id);
                                }
                                var rootControlParams = rootElement_2.dynOptions || {};
                                rootControlParams._element = rootElement_2;
                                var dataSource_1 = $dyn.dataSource(rootElement_2);
                                var controlParams = void 0;
                                if (interaction.RootId == descriptor.Id) {
                                    if (!rootElement_2.getAttribute("data-dyn-form-name") && descriptor.ValueProperties && descriptor.ValueProperties.FormName) {
                                        var name_3 = descriptor.ValueProperties.FormName;
                                        rootElement_2.setAttribute("data-dyn-form-name", name_3);
                                    }
                                    controlParams = rootControlParams;
                                    if (!controlParams._allControls) {
                                        controlParams._allControls = {};
                                    }
                                    var isPartForm = rootControlParams && rootControlParams.TypeName === "PartForm";
                                    if (!isPartForm && descriptor.ValueProperties && descriptor.ValueProperties.RecordContext !== null && descriptor.ValueProperties.RecordContext !== undefined) {
                                        // Update Url with the record context that goes as q parameter in the query
                                        $dyn.ui.updateQueryStringParameter("q", descriptor.ValueProperties.RecordContext ? descriptor.ValueProperties.RecordContext : null);
                                    }
                                }
                                else {
                                    // Finding existing control params
                                    controlParams = $dyn.serverForm.getControlParams(descriptor.Name, rootControlParams);
                                }
                                if (!controlParams) {
                                    // throw new Error('Can not update view model: View model not found, name:' + descriptor.Name);
                                }
                                else {
                                    this._applyDelta(rootControlParams, controlParams, descriptor, dataSource_1, false);
                                }
                                // At the root level a 'create' means the form may need to be displayed as well
                                if (rootVisible &&
                                    interaction.RootId == descriptor.Id &&
                                    $dyn.context(rootElement_2) &&
                                    (rootElement_2.dynReadyState() === $dyn.ui.ReadyState.aborted || // Note: Call _openForm when aborted so that the form can destroy itself.
                                        ($dyn.value($dyn.context(rootElement_2).IsFormReady) && rootElement_2.dynReadyState() === $dyn.ui.ReadyState.loading))) {
                                    this._openForm(rootElement_2);
                                }
                            }
                            else {
                                $dyn.log.server &&
                                    $dyn.log.server("Serverform: Applying delta--no root element found! (expected id %s)", interaction && interaction.RootId ? interaction.RootId : "<unknown>");
                            }
                        }
                        else if (interaction.$type === $dyn.serverForm.InteractionType.deleteViewModel) {
                            // TODO: Should save the last value
                            this.closeFormByRootId(interaction.RootId);
                        }
                        else if (interaction.$type === $dyn.serverForm.InteractionType.setLookupValue) {
                            rootElement_2 = this.getFormElement(interaction.RootId);
                            var rootControl = $dyn.context(rootElement_2);
                            var control = $dyn.ui.findControl(interaction.NamedParameters.ControlName, rootElement_2);
                            if (!control && rootControl) {
                                // search in the open flyouts associated with this form
                                var controlElement = $dyn.ui.findFlyoutControlElement(interaction.NamedParameters.ControlName, rootControl.Id);
                                control = $dyn.context(controlElement);
                            }
                            if (control) {
                                var baseInput = control;
                                var syncWithModel = interaction.NamedParameters.SyncValueFromModel;
                                if (baseInput.isInGrid && baseInput.isInGrid() && baseInput.Root && baseInput.Root.UseReactGrid()) {
                                    var validityControl = baseInput.ReferenceGroup ? baseInput.ReferenceGroup : baseInput;
                                    var serverTrackingId = $dyn.value(validityControl.listControl.SelectedRowTrackingId);
                                    var collectionIndex = validityControl.listControl.getCollectionIndexFromTrackingId(serverTrackingId);
                                    var collectionData = $dyn.value(validityControl.listControl.DataSource);
                                    var model = void 0;
                                    if (validityControl.DataSourceName &&
                                        collectionData[collectionIndex].collectionName !== validityControl.DataSourceName) {
                                        model =
                                            collectionData[collectionIndex].getRelated && collectionData[collectionIndex].getRelated(validityControl.DataSourceName, collectionIndex);
                                    }
                                    else {
                                        model = collectionData[collectionIndex];
                                    }
                                    var dataVersionKey = "_VIRTUALIZED_" + validityControl.Name + "_DataVersion";
                                    var currentVersion = model.getValue(dataVersionKey);
                                    if (currentVersion == undefined) {
                                        currentVersion = 0;
                                    }
                                    model.setValue(dataVersionKey, currentVersion + 1, true, validityControl.Root.Id);
                                    if (!syncWithModel) {
                                        var validityValueKey = "_VIRTUALIZED_" + validityControl.Name + "_Validity";
                                        var currentValidity = model.getValue(validityValueKey);
                                        var newUserValue = interaction.NamedParameters.Value;
                                        if (baseInput.ReferenceGroup) {
                                            newUserValue = currentValidity ? $dyn.util.objectAssign({}, currentValidity.userValue) : {};
                                            newUserValue[control.Name] = interaction.NamedParameters.Value;
                                        }
                                        var newValidity = $dyn.util.objectAssign({}, currentValidity, { userValue: newUserValue });
                                        model.setValue(validityValueKey, newValidity, true, validityControl.Root.Id);
                                    }
                                    $dyn.reactGrid.appliedVirtualizedProperty = true;
                                }
                                else {
                                    if (syncWithModel) {
                                        // If SyncWithModel is true then sync the values on the control. This is necessary in cases such as when a value is cleared out then reselected.
                                        if (baseInput.syncValues) {
                                            baseInput.syncValues();
                                        }
                                    }
                                    else {
                                        // Else set the value in the control to the value that was sent (this is used for invalid values and clientside-only controls)
                                        var newValue = interaction.NamedParameters.Value;
                                        if (baseInput.ReferenceGroup) {
                                            // Note that clientside-only referencegroups may need to be updated to set bound backing value correctly.
                                            baseInput.ReferenceGroup.setChildValue(baseInput, newValue);
                                        }
                                        else {
                                            // Server controls should only edit the value that is shown to the user, not the backing value since it is not valid
                                            // and shouldn't be sent to the server.
                                            if (baseInput.IsServerLookupControl === undefined && control.element) {
                                                var serverId = control.element.getAttribute("data-dyn-serverid");
                                                baseInput.IsServerLookupControl = serverId == undefined ? false : true;
                                            }
                                            if (baseInput.IsServerLookupControl) {
                                                baseInput.updateFormattedValue(newValue);
                                            }
                                            else {
                                                baseInput.setValue(newValue);
                                                // If setting to the same value then formattedValue wont update
                                                if (baseInput.isDisplayedValueDirty && baseInput.isDisplayedValueDirty()) {
                                                    baseInput.syncValues();
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        this._viewInteractionTask &&
                            this._viewInteractionTask.stop(interaction.Descriptor && interaction.Descriptor.Name);
                    }
                }
                this._viewInteractionsTask && this._viewInteractionsTask.stop();
                if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName) && $dyn.reactGrid.appliedVirtualizedProperty) {
                    $dyn.reactGrid.appliedVirtualizedProperty = false;
                    $dyn.serverForm.UpdateModelManager.raiseChanges();
                }
            };
            InteractionHandler.prototype._getFormName = function (descriptor) {
                var rawName = descriptor.Name;
                return rawName.endsWith("_form") ? rawName.substring(0, rawName.length - "_form".length) : rawName;
            };
            InteractionHandler.prototype._openForm = function (rootElement) {
                var rootControl = $dyn.context(rootElement);
                var formName = rootControl.FormName;
                this._openFormTask && this._openFormTask.start(formName);
                $dyn.shell.open({ form: rootControl });
                rootElement.dynPerformance.loadingEnd = window.performance.now();
                rootElement.dynPerformance.loadTime = rootElement.dynPerformance.loadingEnd - rootElement.dynPerformance.loadingStart;
                if (rootElement.dynReadyState() !== $dyn.ui.ReadyState.aborted) {
                    rootElement.dynReadyState($dyn.ui.ReadyState.ready);
                }
                rootElement.dynPerformance.navigationTime = rootElement.dynPerformance.loadingEnd - rootElement.dynPerformance.navigationStart;
                var formLoadComplete = Math.round(rootElement.dynPerformance.navigationTime);
                var telemetryOptions = { targetType: rootControl.TypeName, duration: formLoadComplete };
                $dyn.telemetry.addPerformanceEvent(formName, rootControl.Id, $dyn.telemetry.PerformanceEvents.openStop, telemetryOptions);
                $dyn.log.performance && $dyn.log.performance("performance: Form navigation time: %s, %s (ms)", formName, formLoadComplete);
                $dyn.log.performance && $dyn.log.performance("performance: Form load time: %s, %s (ms)", formName, rootElement.dynPerformance.loadTime);
                $dyn.serverForm.trackRenderTime(formName, rootElement.dynPerformance.loadTime);
                this._openFormTask && this._openFormTask.stop(formName);
            };
            /** Closes the form */
            InteractionHandler.prototype._closeForm = function (rootElement) {
                var allControls = null;
                if (rootElement) {
                    if (rootElement.dynOptions && rootElement.dynOptions._allControls) {
                        allControls = rootElement.dynOptions._allControls;
                        rootElement.dynOptions._allControls = null;
                    }
                    if (rootElement.dynVirtualizedProperties) {
                        rootElement.dynVirtualizedProperties = null;
                    }
                    var rootControl = $dyn.context(rootElement);
                    if (rootControl) {
                        // Close a form's dialogs first
                        for (var i = $dyn.length(rootControl.dialogStack) - 1; i >= 0; i--) {
                            var dialogElement = $dyn.value(rootControl.dialogStack)[i];
                            this._closeForm(dialogElement);
                        }
                        // Server already closed the form so no need to send a RequestClose command to the server
                        rootControl.PrepareClientOnlyClose();
                        $dyn.shell.close({ form: rootControl });
                    }
                    if (allControls) {
                        this._cleanupControls(allControls);
                    }
                }
            };
            /** Cleans up orphaned controls when a form is closed */
            InteractionHandler.prototype._cleanupControls = function (allControls) {
                if (allControls) {
                    var controlNames = Object.keys(allControls);
                    for (var i = 0, len = controlNames.length; i < len; i++) {
                        var controlName = controlNames[i];
                        var control = allControls[controlName];
                        var element = control._element;
                        if (element && !element.parentNode) {
                            // Removed controls are not unbound due to calling close on the form because they are not in the dom (i.e. are no longer part of the form)
                            // and need to cleaned up here.
                            $dyn.unbind(element);
                        }
                    }
                }
            };
            InteractionHandler.prototype._applyVirtualizedProperty = function (name, value, rootControlParams, controlParams, descriptor, parentDataSource, datasourceName, virtualizer) {
                if (descriptor.VirtualizedProperties && descriptor.VirtualizedProperties.indexOf(name) >= 0) {
                    var map_1 = rootControlParams._element.dynVirtualizedProperties;
                    if (!map_1) {
                        map_1 = rootControlParams._element.dynVirtualizedProperties = new $dyn.serverForm.VirtualizedProperties();
                    }
                    var controlName_1 = descriptor.Name;
                    var currentDescriptor = controlParams._descriptor;
                    var virtualProperties = currentDescriptor.virtualProperties;
                    if (!virtualProperties) {
                        virtualProperties = currentDescriptor.virtualProperties = {};
                    }
                    virtualProperties[name] = virtualizer;
                    var modelCollectionName = "";
                    if (datasourceName === undefined) {
                        modelCollectionName = controlParams.DataSourceName;
                    }
                    else {
                        modelCollectionName = $dyn.serverForm.getCollectionName(datasourceName);
                        if (!controlParams.DataSourceName) {
                            controlParams.DataSourceName = modelCollectionName;
                        }
                    }
                    var relatedCollection_1 = parentDataSource ? parentDataSource.getRelatedCollection(modelCollectionName) : null;
                    if (modelCollectionName !== undefined && modelCollectionName !== "" && relatedCollection_1) {
                        if (!map_1.datasourceMap[controlName_1]) {
                            map_1.datasourceMap[controlName_1] = relatedCollection_1;
                        }
                    }
                    var controlMetadata = $dyn.serverForm.metadata[descriptor.TypeName];
                    var virtualDefaultValue = void 0;
                    if (controlMetadata && controlMetadata.ValueProperties) {
                        var valueProperty = controlMetadata.ValueProperties[name];
                        if (valueProperty) {
                            virtualDefaultValue = valueProperty.DefaultVirtualValue;
                        }
                    }
                    var metadataProperties = controlMetadata.ValueProperties;
                    if (!metadataProperties) {
                        metadataProperties = controlMetadata.ValueProperties = {};
                    }
                    var propertyMetadata_1 = metadataProperties[name];
                    if (!propertyMetadata_1) {
                        propertyMetadata_1 = metadataProperties[name] || {};
                    }
                    var propertyCollection = value;
                    if (propertyCollection instanceof Array) {
                        map_1.setProperty(controlName_1, name, propertyCollection, parentDataSource._formId);
                        var backingComputedName_1 = "__virtualizedProperty_" + name;
                        if (controlParams[backingComputedName_1] === undefined) {
                            (function (_name, defaultVirtualValue) {
                                var lastValue = defaultVirtualValue;
                                value = controlParams[backingComputedName_1] = $dyn.computed(function () {
                                    var index;
                                    if (relatedCollection_1) {
                                        index = $dyn.value(relatedCollection_1.selectedIndex);
                                    }
                                    var newValue = map_1.getProperty(controlName_1, _name, index, $dyn.value(lastValue));
                                    lastValue = newValue;
                                    return $dyn.value(newValue);
                                });
                            })(name, virtualDefaultValue);
                            controlParams[backingComputedName_1]._backingComputedObserver = $dyn.observe(controlParams[backingComputedName_1], function (propertyValue) {
                                // set the value on control directly if property has backing getter/setters
                                if (propertyMetadata_1.PropertyName) {
                                    var control = $dyn.context(controlParams._element) || controlParams;
                                    control[name] = propertyValue;
                                }
                                else {
                                    if (!$dyn.isObservable(controlParams[name])) {
                                        controlParams[name] = controlParams[backingComputedName_1];
                                    }
                                    var observableProp = controlParams[name];
                                    observableProp(propertyValue);
                                }
                            });
                        }
                        if (parentDataSource && parentDataSource.getValue("UseReactGrid") && relatedCollection_1) {
                            $dyn.reactGrid.appliedVirtualizedProperty = true;
                            // Check that trackingIds are sent down and that there is a corresponding trackingId for each value in propertyCollection
                            var trackingIds = descriptor.VirtualizedPropertiesTrackingIds && descriptor.VirtualizedPropertiesTrackingIds[name];
                            var hasTrackingIds = trackingIds && trackingIds.length && trackingIds.length === propertyCollection.length;
                            // Fallback for server versions prior to tracking ids being provided
                            var adjustmentToIndex = void 0;
                            var collectionIndex = void 0;
                            if (!hasTrackingIds) {
                                // loop through property collection and call setValue on the corresponding models in the collection
                                adjustmentToIndex = 0;
                                if ($dyn.serverForm.ModelManager.loadDirection !== $dyn.ui.ScrollDirection.up) {
                                    // UpdateModelCollection interactions are run before UpdateViewModel interactions
                                    adjustmentToIndex = $dyn.length(relatedCollection_1.items) - relatedCollection_1.numberOfClientRows - propertyCollection.length;
                                }
                            }
                            for (var i = 0; i < propertyCollection.length; i++) {
                                // Ignoring null values
                                if (propertyCollection[i] === null) {
                                    continue;
                                }
                                var model = void 0;
                                if (hasTrackingIds) {
                                    var id = modelCollectionName + "_" + trackingIds[i];
                                    model = $dyn.serverForm.ModelManager.getModel(id);
                                }
                                else {
                                    collectionIndex = i + adjustmentToIndex;
                                    if (collectionIndex < 0 || collectionIndex >= $dyn.length(relatedCollection_1.items)) {
                                        continue;
                                    }
                                    model = $dyn.value(relatedCollection_1.items)[collectionIndex];
                                }
                                if (!model) {
                                    continue;
                                }
                                switch (name) {
                                    case "DisplayOptions":
                                        var displayOptions = propertyCollection[i];
                                        var containerStyle = {};
                                        var useContainerStyle = false;
                                        var inputStyle = {};
                                        var useInputStyle = false;
                                        if (displayOptions) {
                                            // tslint:disable:no-bitwise
                                            if ($dyn.util.stringToBoolean(displayOptions.useBackColor) && displayOptions.backcolor) {
                                                useContainerStyle = true;
                                                var r = (displayOptions.backcolor & 0xff0000) >> 16;
                                                var g = (displayOptions.backcolor & 0xff00) >> 8;
                                                var b = displayOptions.backcolor & 0xff;
                                                var rgbaBackColorVal = "rgb(" + r + "," + g + "," + b + ")";
                                                containerStyle.backgroundColor = rgbaBackColorVal;
                                            }
                                            if ($dyn.util.stringToBoolean(displayOptions.useTextColor) && displayOptions.textcolor) {
                                                useInputStyle = true;
                                                var r = (displayOptions.textcolor & 0xff0000) >> 16;
                                                var g = (displayOptions.textcolor & 0xff00) >> 8;
                                                var b = displayOptions.textcolor & 0xff;
                                                var rgbaTextColorVal = "rgb(" + r + "," + g + "," + b + ")";
                                                inputStyle.color = rgbaTextColorVal;
                                            }
                                            // tslint:enable:no-bitwise
                                            if ($dyn.util.stringToBoolean(displayOptions.fontWeight)) {
                                                useInputStyle = true;
                                                inputStyle.fontWeight = "bold";
                                            }
                                            if ($dyn.util.stringToBoolean(displayOptions.fontStyle)) {
                                                useInputStyle = true;
                                                inputStyle.fontStyle = "italic";
                                            }
                                            if (displayOptions.textDecoration) {
                                                useInputStyle = true;
                                                inputStyle.textDecoration = displayOptions.textDecoration;
                                            }
                                        }
                                        if (controlName_1 === "ColorPlaceholder" && $dyn.value(rootControlParams.FormName) === "SysAppDesignerPane") {
                                            var backgroundColorPropertyName = "_VIRTUALIZED_AppIconAndColor_BackgroundColor";
                                            if (!model.doesPropertyExist(backgroundColorPropertyName) && controlParams.listControl) {
                                                controlParams.listControl.applyVirtualizedPropertyFirstTime();
                                            }
                                            model.setValue(backgroundColorPropertyName, containerStyle.backgroundColor, true, rootControlParams.id);
                                        }
                                        else {
                                            var containerStylePropertyName = "_VIRTUALIZED_" + controlName_1 + "_ContainerStyle";
                                            if (!useContainerStyle) {
                                                containerStyle = null;
                                            }
                                            if (!model.doesPropertyExist(containerStylePropertyName) && controlParams.listControl) {
                                                controlParams.listControl.applyVirtualizedPropertyFirstTime();
                                            }
                                            model.setValue(containerStylePropertyName, containerStyle, true, rootControlParams.id);
                                            var inputStylePropertyName = "_VIRTUALIZED_" + controlName_1 + "_InputStyle";
                                            if (!useInputStyle) {
                                                inputStyle = null;
                                            }
                                            if (!model.doesPropertyExist(inputStylePropertyName) && controlParams.listControl) {
                                                controlParams.listControl.applyVirtualizedPropertyFirstTime();
                                            }
                                            model.setValue(inputStylePropertyName, inputStyle, true, rootControlParams.id);
                                        }
                                        break;
                                    case "IsCorrection":
                                        model.setValue("_VIRTUALIZED_" + controlName_1 + "_" + name, $dyn.util.stringToBoolean(propertyCollection[i]), true, rootControlParams.id);
                                        break;
                                    default:
                                        model.setValue("_VIRTUALIZED_" + controlName_1 + "_" + name, propertyCollection[i], true, rootControlParams.id);
                                }
                            }
                        }
                    }
                }
            };
            InteractionHandler.prototype._applyProperties = function (rootControlParams, controlParams, descriptor, parentDataSource, parentDescriptor) {
                if (descriptor.TypeName) {
                    controlParams._typeName = descriptor.TypeName;
                }
                controlParams._name = descriptor.Name;
                controlParams._serverId = descriptor.Id;
                // Set server Id attributes to control element
                // We assume that element is present already
                if (controlParams._serverId && controlParams !== rootControlParams) {
                    controlParams._element.setAttribute("data-dyn-serverid", controlParams._serverId);
                    controlParams._element.setAttribute("data-dyn-rootserverid", rootControlParams._serverId);
                }
                var virtualizedProperties = descriptor.VirtualizedProperties;
                if (descriptor.ValueProperties && descriptor.ValueProperties.Resource) {
                    controlParams._resource = descriptor.ValueProperties.Resource;
                    delete descriptor.ValueProperties.Resource;
                }
                // Delegate control specific descriptor handling to control adapter
                var controlAdapter = $dyn.serverForm.controlAdapters[descriptor.TypeName];
                if (controlAdapter) {
                    controlAdapter(rootControlParams, controlParams, descriptor, parentDataSource, parentDescriptor);
                }
                var currentDescriptor = controlParams._descriptor;
                if (!currentDescriptor) {
                    currentDescriptor = controlParams._descriptor = {
                        referencePropertyChanged: new $dyn.eventHost(),
                        virtualizedPropertyChanged: new $dyn.eventHost(),
                    };
                }
                var datasourceName = descriptor.DataSourceName;
                if ((!datasourceName || datasourceName === "") && currentDescriptor) {
                    datasourceName = currentDescriptor.DataSourceName;
                }
                var controlMetadata = $dyn.serverForm.metadata[descriptor.TypeName];
                if (!controlMetadata) {
                    controlMetadata = $dyn.serverForm.metadata[descriptor.TypeName] = $dyn.serverForm.metadata.Control;
                }
                var metadataProperties = controlMetadata.ValueProperties;
                if (!metadataProperties) {
                    metadataProperties = controlMetadata.ValueProperties = {};
                }
                var currentVirtualizedProperties = controlParams._descriptor.virtualizedProperties;
                if (!currentVirtualizedProperties) {
                    currentVirtualizedProperties = controlParams._descriptor.virtualizedProperties = [];
                }
                var changedVirtualizedProperties = {};
                // tslint:disable-next-line:forin
                for (var name_4 in descriptor.ValueProperties) {
                    var valueProp = descriptor.ValueProperties[name_4];
                    var isVirtualized = virtualizedProperties && virtualizedProperties.indexOf(name_4) >= 0 ? true : false;
                    this._applyPropertyTask && this._applyPropertyTask.start(name_4);
                    var propertyMetadata = metadataProperties[name_4];
                    if (!propertyMetadata) {
                        propertyMetadata = metadataProperties[name_4] || {};
                    }
                    var value_1 = valueProp;
                    if (typeof valueProp === "object") {
                        var serializer = $dyn.serverForm.serializers.default;
                        value_1 = serializer.deserialize(valueProp, controlParams, rootControlParams);
                        if (isVirtualized) {
                            if (currentVirtualizedProperties.indexOf(name_4) === -1) {
                                changedVirtualizedProperties[name_4] = true;
                                currentVirtualizedProperties.push(name_4);
                            }
                            this._applyVirtualizedProperty(name_4, value_1, rootControlParams, controlParams, descriptor, parentDataSource, datasourceName, propertyMetadata.Virtualizer);
                        }
                    }
                    if (propertyMetadata.PropertyName) {
                        if (!isVirtualized) {
                            var control = $dyn.context(controlParams._element) || controlParams;
                            control[propertyMetadata.PropertyName] = value_1;
                        }
                    }
                    else {
                        if (!$dyn.isObservable(controlParams[name_4])) {
                            var controlContext = $dyn.context(controlParams._element);
                            if (controlContext && $dyn.isObservable(controlContext[name_4])) {
                                controlParams[name_4] = controlContext[name_4];
                            }
                            else {
                                controlParams[name_4] = $dyn.observable();
                            }
                        }
                        var observableProp = controlParams[name_4];
                        // Remove any existing bound property bindings.
                        $dyn.disposeOneWayBinding(observableProp);
                        observableProp.__bindingUpdating = true;
                        if (!isVirtualized) {
                            observableProp(value_1);
                        }
                        observableProp.__bindingUpdating = false;
                        var trigger = this._getPropertyTrigger(name_4, descriptor);
                        if (trigger) {
                            var propertyChangeOptions = { command: name_4 };
                            propertyChangeOptions.TargetId = descriptor.Id;
                            if (trigger.ChangeAction && trigger.ChangeAction.Properties) {
                                propertyChangeOptions.AutoPostback = trigger.ChangeAction.Properties.ProcessChanges;
                            }
                            $dyn.serverForm.updateTrigger(controlParams, observableProp, propertyChangeOptions);
                        }
                        if ($dyn.debug.general) {
                            controlParams[name_4].__unboundProp = {
                                name: name_4,
                                options: controlParams,
                            };
                            delete controlParams[name_4].__boundProp;
                        }
                    }
                    this._applyPropertyTask && this._applyPropertyTask.stop(name_4);
                }
                // SERIALIZED COLLECTION
                // tslint:disable-next-line:forin
                for (var name_5 in descriptor.SerializedValueCollectionProperties) {
                    var collectionProp = descriptor.SerializedValueCollectionProperties[name_5];
                    var isVirtualized = virtualizedProperties && virtualizedProperties.indexOf(name_5) >= 0 ? true : false;
                    this._applyPropertyTask && this._applyPropertyTask.start(name_5);
                    var propertyMetadata = metadataProperties[name_5];
                    if (!propertyMetadata) {
                        propertyMetadata = metadataProperties[name_5] || {};
                    }
                    var value_2 = void 0;
                    var serializer = $dyn.serverForm.serializers[$dyn.serverForm.ValueType.collection];
                    value_2 = serializer.deserialize(collectionProp, controlParams, rootControlParams);
                    if (isVirtualized) {
                        if (currentVirtualizedProperties.indexOf(name_5) === -1) {
                            changedVirtualizedProperties[name_5] = true;
                            currentVirtualizedProperties.push(name_5);
                        }
                        this._applyVirtualizedProperty(name_5, value_2, rootControlParams, controlParams, descriptor, parentDataSource, datasourceName, propertyMetadata.Virtualizer);
                    }
                    if (!$dyn.isObservable(controlParams[name_5])) {
                        var controlContext = $dyn.context(controlParams._element);
                        if (controlContext && $dyn.isObservable(controlContext[name_5])) {
                            controlParams[name_5] = controlContext[name_5];
                        }
                        else {
                            controlParams[name_5] = $dyn.observable();
                        }
                    }
                    var observableProp = controlParams[name_5];
                    // Remove any existing bound property bindings.
                    $dyn.disposeOneWayBinding(observableProp);
                    observableProp.__bindingUpdating = true;
                    if (!isVirtualized) {
                        observableProp(value_2);
                    }
                    observableProp.__bindingUpdating = false;
                    var trigger = this._getPropertyTrigger(name_5, descriptor);
                    if (trigger) {
                        var propertyChangeOptions = { command: name_5 };
                        propertyChangeOptions.TargetId = descriptor.Id;
                        if (trigger.ChangeAction && trigger.ChangeAction.Properties) {
                            propertyChangeOptions.AutoPostback = trigger.ChangeAction.Properties.ProcessChanges;
                        }
                        $dyn.serverForm.updateTrigger(controlParams, observableProp, propertyChangeOptions);
                    }
                    if ($dyn.debug.general) {
                        controlParams[name_5].__unboundProp = {
                            name: name_5,
                            options: controlParams,
                        };
                        delete controlParams[name_5].__boundProp;
                    }
                    this._applyPropertyTask && this._applyPropertyTask.stop(name_5);
                } // END SERIALIZED COLLECTION
                // SERIALIZED VALUE
                // tslint:disable-next-line:forin
                for (var name_6 in descriptor.SerializedValueProperties) {
                    var serializedValueProp = descriptor.SerializedValueProperties[name_6];
                    var isVirtualized = virtualizedProperties && virtualizedProperties.indexOf(name_6) >= 0 ? true : false;
                    this._applyPropertyTask && this._applyPropertyTask.start(name_6);
                    var propertyMetadata = metadataProperties[name_6];
                    if (!propertyMetadata) {
                        propertyMetadata = metadataProperties[name_6] || {};
                    }
                    var value_3 = void 0;
                    var serializer = $dyn.serverForm.serializers[$dyn.serverForm.ValueType.serialized];
                    value_3 = serializer.deserialize(serializedValueProp, controlParams, rootControlParams);
                    if (isVirtualized) {
                        if (currentVirtualizedProperties.indexOf(name_6) === -1) {
                            changedVirtualizedProperties[name_6] = true;
                            currentVirtualizedProperties.push(name_6);
                        }
                        this._applyVirtualizedProperty(name_6, value_3, rootControlParams, controlParams, descriptor, parentDataSource, datasourceName, propertyMetadata.Virtualizer);
                    }
                    if (propertyMetadata.PropertyName) {
                        // for virtualized property we have already set the computed during _applyVirtualizedProperty
                        if (!isVirtualized) {
                            var control = $dyn.context(controlParams._element) || controlParams;
                            control[propertyMetadata.PropertyName] = value_3;
                        }
                    }
                    else {
                        if (!$dyn.isObservable(controlParams[name_6])) {
                            var controlContext = $dyn.context(controlParams._element);
                            if (controlContext && $dyn.isObservable(controlContext[name_6])) {
                                controlParams[name_6] = controlContext[name_6];
                            }
                            else {
                                controlParams[name_6] = $dyn.observable();
                            }
                        }
                        var observableProp = controlParams[name_6];
                        // Remove any existing bound property bindings.
                        $dyn.disposeOneWayBinding(observableProp);
                        observableProp.__bindingUpdating = true;
                        // for virtualized property we have already set the computed during _applyVirtualizedProperty
                        if (!isVirtualized) {
                            observableProp(value_3);
                        }
                        observableProp.__bindingUpdating = false;
                        var trigger = this._getPropertyTrigger(name_6, descriptor);
                        if (trigger) {
                            var propertyChangeOptions = { command: name_6 };
                            propertyChangeOptions.TargetId = descriptor.Id;
                            if (trigger.ChangeAction && trigger.ChangeAction.Properties) {
                                propertyChangeOptions.AutoPostback = trigger.ChangeAction.Properties.ProcessChanges;
                            }
                            $dyn.serverForm.updateTrigger(controlParams, observableProp, propertyChangeOptions);
                        }
                        if ($dyn.debug.general) {
                            controlParams[name_6].__unboundProp = {
                                name: name_6,
                                options: controlParams,
                            };
                            delete controlParams[name_6].__boundProp;
                        }
                        this._applyPropertyTask && this._applyPropertyTask.stop(name_6);
                    }
                } // END SERIALIZED VALUE
                if (Object.keys(changedVirtualizedProperties).length > 0) {
                    controlParams._descriptor.virtualizedPropertyChanged.raise(changedVirtualizedProperties);
                }
                var referenceProperties = controlParams._descriptor.referenceProperties;
                if (!referenceProperties) {
                    referenceProperties = controlParams._descriptor.referenceProperties = {};
                }
                var changedReferenceProperties = [];
                // tslint:disable-next-line:forin
                for (var name_7 in descriptor.ReferenceProperties) {
                    this._applyPropertyTask && this._applyPropertyTask.start(name_7);
                    // Field is a reference property (datasource with field/datamethod)
                    var referenceProp = descriptor.ReferenceProperties[name_7];
                    var previousProperty = referenceProperties[name_7];
                    if (!this._areReferencePropertiesEqual(previousProperty, referenceProp)) {
                        // update the descriptor
                        referenceProperties[name_7] = referenceProp;
                        changedReferenceProperties.push(name_7);
                        var modelCollectionName = $dyn.serverForm.getCollectionName(referenceProp.ModelName);
                        var modelFieldName = $dyn.serverForm.getPropertyName(referenceProp.ModelFieldName);
                        var control = $dyn.context(controlParams._element) || controlParams;
                        control.FieldName = modelFieldName;
                        control.DataSourceName = modelCollectionName;
                        var boundProp = $dyn.getFieldObservable(modelFieldName, $dyn.getModel(modelCollectionName, parentDataSource));
                        // Ensure that the property is observable.
                        if (!$dyn.isObservable(controlParams[name_7])) {
                            controlParams[name_7] = $dyn.observable();
                        }
                        var observableProp = controlParams[name_7];
                        observableProp.__ModelName = modelCollectionName;
                        observableProp.__ModelFieldName = modelFieldName;
                        $dyn.oneWayBinding(boundProp, observableProp);
                        var trigger = this._getPropertyTrigger(name_7, descriptor);
                        if (trigger) {
                            var propertyChangeOptions = { command: name_7 };
                            propertyChangeOptions.TargetId = descriptor.Id;
                            $dyn.serverForm.updateTrigger(controlParams, observableProp, propertyChangeOptions);
                        }
                        if ($dyn.debug.general) {
                            controlParams[name_7].__boundProp = {
                                boundDataSource: parentDataSource,
                                boundProp: boundProp,
                                modelFieldName: modelFieldName,
                                modelName: modelCollectionName,
                                name: name_7,
                                options: controlParams,
                            };
                            delete controlParams[name_7].__unboundProp;
                        }
                    }
                    if (changedReferenceProperties.length > 0) {
                        controlParams._descriptor.referencePropertyChanged.raise(changedReferenceProperties);
                    }
                    this._applyPropertyTask && this._applyPropertyTask.stop(name_7);
                }
                this._applyCommands(rootControlParams, controlParams, descriptor);
            };
            InteractionHandler.prototype._areReferencePropertiesEqual = function (prop1, prop2) {
                if (prop1 && prop2 && prop1.Name == prop2.Name && prop1.ModelName == prop2.ModelName && prop1.ModelFieldName == prop2.ModelFieldName) {
                    return true;
                }
                return false;
            };
            InteractionHandler.prototype._applyCommands = function (rootControlParams, controlParams, descriptor) {
                if (!descriptor.Commands) {
                    return; // Not all descriptors have commands
                }
                var commands = Object.keys(descriptor.Commands);
                for (var i = 0, len = commands.length; i < len; i++) {
                    var name_8 = commands[i];
                    this._applyCommandTask && this._applyCommandTask.start(name_8);
                    var command = descriptor.Commands[name_8];
                    command.TargetId = descriptor.Id;
                    var valueTypeName = command.ValueTypeName;
                    var serializer = $dyn.serverForm.serializers[valueTypeName];
                    if (!serializer) {
                        serializer = $dyn.serverForm.serializers.InteractionCommand;
                        $dyn.logWarning("Unknown command serializer: %s, control type: %s, command: %s, descriptor: %o", valueTypeName, descriptor.TypeName, name_8, descriptor);
                    }
                    var commandValue = serializer.deserialize(command, controlParams, rootControlParams);
                    var control = $dyn.context(controlParams._element) || controlParams;
                    $dyn.setObservableValue(control, name_8, commandValue);
                    this._applyCommandTask && this._applyCommandTask.stop(name_8);
                }
            };
            InteractionHandler.prototype._applyDelta = function (rootControlParams, controlParams, descriptor, dataSource, parentCreated) {
                if (descriptor.TypeName !== undefined && controlParams.TypeName !== undefined && controlParams.TypeName !== descriptor.TypeName) {
                    $dyn.log.server &&
                        $dyn.log.server("ServerForm: Control type mismatch for %s in descriptor and new TypeName - %s , current TypeName- %s", descriptor.TypeName, controlParams.TypeName);
                }
                if (descriptor.TypeName === undefined) {
                    // TypeName is used in several places so fix it if not received
                    descriptor.TypeName = controlParams.TypeName;
                }
                this._applyDeltaTaskByName && this._applyDeltaTaskByName.start(descriptor.Name + "-" + descriptor.TypeName);
                this._applyDeltaTask && this._applyDeltaTask.start(descriptor.TypeName);
                this._applyPropertiesByNameTask && this._applyPropertiesByNameTask.start(descriptor.Name + "-" + descriptor.TypeName);
                this._applyPropertiesTask && this._applyPropertiesTask.start(descriptor.TypeName);
                var control;
                if (!parentCreated) {
                    control = $dyn.context(controlParams._element);
                    if (control && control.setUpdating) {
                        control.setUpdating(true);
                    }
                    // Should we pass in the parent data source?
                    this._applyProperties(rootControlParams, controlParams, descriptor, dataSource);
                }
                this._applyPropertiesTask && this._applyPropertiesTask.stop(descriptor.TypeName);
                this._applyPropertiesByNameTask && this._applyPropertiesByNameTask.stop(descriptor.Name + "-" + descriptor.TypeName);
                $dyn.serverForm._debugDescriptor(controlParams._element, descriptor);
                if (rootControlParams._element.dynReadyState() === $dyn.ui.ReadyState.aborted) {
                    // Only apply form-level properties so that RequestClose can be triggered.
                    $dyn.log.server &&
                        $dyn.log.server("ServerForm: Applying delta for aborted form %s / %s -- only applying form level properties", rootControlParams._element.id, $dyn.context(rootControlParams._element).Name);
                    return;
                }
                var childViewModels = descriptor.ChildViewModels;
                if ($.isArray(childViewModels)) {
                    var changed = false;
                    var dataBindList = [];
                    var childrenObservable = $dyn._getChildren(controlParams._element);
                    var oldChildren = childrenObservable().slice();
                    // If the length of the old children is different from the new children, value of changed flag needs to be set to true if the parent is a container.
                    if (oldChildren.length !== childViewModels.length) {
                        if (!parentCreated) {
                            changed = true;
                        }
                    }
                    for (var i = 0, len = childViewModels.length; i < len; i++) {
                        var childDescriptor = childViewModels[i];
                        var currentDataSource = dataSource;
                        this._fixDescriptor(childDescriptor, descriptor, currentDataSource, rootControlParams);
                        // Only creates will have descriptors, updates will be top level.
                        if (childDescriptor) {
                            // Before creating DOM structure for the control, make sure it doesn't already exist
                            var createControl = false;
                            var childControlParams = $dyn.serverForm.getControlParams(childDescriptor.Name, rootControlParams);
                            var domNode = childControlParams ? childControlParams._element : null;
                            if (domNode) {
                                // TypeName is used in several places
                                if (childDescriptor.TypeName == undefined) {
                                    childDescriptor.TypeName = $dyn.roleType(domNode);
                                }
                                if ($dyn.roleType(domNode) === childDescriptor.TypeName || domNode.getAttribute("data-dyn-role-orig") === childDescriptor.TypeName) {
                                    if (!$dyn.context(domNode)) {
                                        var parent_1 = $dyn.templatedParentElement(domNode);
                                        if (parent_1 && parent_1 !== controlParams._element && $dyn.context(controlParams._element)) {
                                            // Control is not data bound
                                            dataBindList.push(domNode);
                                        }
                                    }
                                }
                                else {
                                    createControl = true;
                                    this._controlRoleFaultTask && this._controlRoleFaultTask.start(childDescriptor.Name + "-" + childDescriptor.TypeName);
                                    if (domNode.dynTemplatedParent === controlParams._element && !controlParams._element.hasAttribute("data-dyn-container")) {
                                        // Creating a new control with same name under same parent but different role
                                        // Remove the old one
                                        if (domNode.parentNode !== controlParams._element) {
                                            $dyn.logError("Control has no parent.");
                                            if (domNode.remove) {
                                                domNode.remove();
                                            }
                                        }
                                        else {
                                            controlParams._element.removeChild(domNode);
                                        }
                                        $dyn.unbind(domNode);
                                    }
                                    if (childDescriptor.TypeName !== undefined) {
                                        $dyn.log.server &&
                                            $dyn.log.server("ServerForm: Control type mismatch for %s in descriptor and new TypeName - %s , current TypeName- %s", childDescriptor.Name, childDescriptor.TypeName, $dyn.roleType(domNode));
                                    }
                                    this._controlRoleFaultTask && this._controlRoleFaultTask.stop(childDescriptor.Name + "-" + childDescriptor.TypeName);
                                }
                            }
                            else {
                                createControl = true;
                            }
                            if (!createControl && childControlParams && childControlParams.Root && $dyn.value(childControlParams.Root.UseReactGrid)) {
                                var childInGrid = childControlParams.isInGrid && childControlParams.isInGrid() ? true : false;
                                var controlIsGrid = controlParams.TypeName === "RowTemplate";
                                if (childInGrid !== controlIsGrid) {
                                    // if moving from outside to inside react grid, or from inside to outside
                                    // we need to recreate the control
                                    createControl = true;
                                }
                            }
                            var options_1 = void 0;
                            if (descriptor.TypeName === "Table") {
                                if (descriptor.DataSourceName === undefined) {
                                    descriptor.DataSourceName = descriptor.Name + "_tableds_";
                                }
                                currentDataSource = (function (computedDataSource, dataSourceName, dataSourceIndex) {
                                    return $dyn.computed(function () {
                                        return computedDataSource.getRelatedCollection(dataSourceName).items()[dataSourceIndex];
                                    });
                                })(currentDataSource, descriptor.DataSourceName, i);
                            }
                            if (createControl) {
                                // Insert location should be before the last child in the dom
                                options_1 = this._createControl(rootControlParams, childDescriptor, descriptor, currentDataSource);
                                // Force grid to be in paging mode (non-infinite scroll if debug flag is present)
                                if (options_1 && options_1._typeName && options_1._typeName === "List") {
                                    // pass in trackingid getter to grid
                                    var getDataId = options_1.GetDataId;
                                    if (!getDataId) {
                                        options_1.GetDataId = function (item) {
                                            return item.masterTrackingId;
                                        };
                                    }
                                    // pass in the the version getter to grid
                                    var getDataVersion = options_1.GetDataVersion;
                                    if (!getDataVersion) {
                                        options_1.GetDataVersion = function (item) {
                                            var itemVersion = 0;
                                            if (item.getVersion) {
                                                itemVersion = item.getVersion();
                                            }
                                            return itemVersion;
                                        };
                                    }
                                    if ($dyn.debug.gridPaging) {
                                        options_1.InfiniteScroll = $dyn.observable(false);
                                    }
                                }
                                domNode = options_1._element;
                                var parentContext = $dyn.context(controlParams._element);
                                if (parentContext) {
                                    dataBindList.push(domNode);
                                }
                            }
                            else {
                                options_1 = domNode.dynOptions;
                                // If the parent is data bound and the item is not data bound, then add the item to the data binding list
                                if (!$dyn.context(domNode)) {
                                    var parentContext = $dyn.context(controlParams._element);
                                    if (parentContext) {
                                        dataBindList.push(domNode);
                                    }
                                }
                            }
                            var oldChild = oldChildren[i];
                            if (parentCreated) {
                                // TODO: Parent role should be doing this
                                controlParams._element.appendChild(domNode);
                            }
                            else if (createControl || (oldChild && oldChild.getAttribute("data-dyn-controlname") !== childDescriptor.Name)) {
                                // Container's content handler will handle DOM operations
                                if (!controlParams._element.hasAttribute("data-dyn-container")) {
                                    if (oldChild && oldChild.parentNode === controlParams._element) {
                                        controlParams._element.insertBefore(domNode, oldChild);
                                    }
                                    else {
                                        controlParams._element.appendChild(domNode);
                                    }
                                }
                                changed = true;
                            }
                            this._applyDelta(rootControlParams, options_1, childDescriptor, currentDataSource, createControl);
                            if (domNode) {
                                // The node is only created if the descriptor isn't "empty".
                                childrenObservable.set(i, domNode);
                            }
                        }
                    }
                    this._applyChildrenDeltaTask && this._applyChildrenDeltaTask.start(descriptor.Name + "-" + descriptor.TypeName);
                    if (changed) {
                        childrenObservable().length = childViewModels.length;
                        childrenObservable.valueChanged.raise();
                        // For all the children that are no longer parented to this container
                        // they have been moved or deleted and in that case we need to make them valid.
                        // Specifically in the removed case, so we can update the form's invalid control list.
                        for (var i = 0, len = oldChildren.length; i < len; i++) {
                            if (childrenObservable().indexOf(oldChildren[i]) === -1) {
                                var removedControl = $dyn.context(oldChildren[i]);
                                if (removedControl) {
                                    if (removedControl.Root && removedControl.Root.HasInvalidControls()) {
                                        if (removedControl.IsValid) {
                                            removedControl.IsValid(true);
                                        }
                                        if (removedControl.Children) {
                                            $dyn.util.validateChildren(removedControl);
                                        }
                                    }
                                    if (!controlParams._element.hasAttribute("data-dyn-container")) {
                                        controlParams._element.removeChild(removedControl._element);
                                        $(removedControl._element).off();
                                    }
                                }
                            }
                        }
                    }
                    for (var i = 0, len = dataBindList.length; i < len; i++) {
                        // Our parent was not created and not a new child
                        var domNode = dataBindList[i];
                        var parentRole = $dyn.role((domNode.parentNode || domNode));
                        // TODO: Investigate rebind cause by this
                        parentRole.dataBindChild(domNode, controlParams._element.dynContext);
                    }
                    if (changed && $dyn.context(controlParams._element)) {
                        $dyn.context(controlParams._element).Children.valueChanged.raise();
                    }
                    this._applyChildrenDeltaTask && this._applyChildrenDeltaTask.stop(descriptor.Name + "-" + descriptor.TypeName);
                }
                if (!parentCreated && control && control.setUpdating) {
                    control.setUpdating(false);
                }
                this._applyDeltaTask && this._applyDeltaTask.stop(descriptor.TypeName);
                this._applyDeltaTaskByName && this._applyDeltaTaskByName.stop(descriptor.Name + "-" + descriptor.TypeName);
            };
            InteractionHandler.prototype._propertyValue = function (propertyName, descriptor) {
                var property;
                if (descriptor.ValueProperties) {
                    property = descriptor.ValueProperties[propertyName];
                    if (property) {
                        return property;
                    }
                }
                if (descriptor.SerializedValueProperties) {
                    property = descriptor.SerializedValueProperties[propertyName];
                    if (property) {
                        return property;
                    }
                }
                if (descriptor.SerializedValueCollectionProperties) {
                    property = descriptor.SerializedValueCollectionProperties[propertyName];
                    if (property) {
                        return property;
                    }
                }
            };
            InteractionHandler.prototype._getPropertyTrigger = function (propertyName, descriptor) {
                if (descriptor.PropertyTriggers) {
                    return descriptor.PropertyTriggers[propertyName];
                }
            };
            InteractionHandler.prototype._getCommand = function (commandName, descriptor) {
                if (descriptor.Commands) {
                    return descriptor.Commands[commandName];
                }
            };
            InteractionHandler.prototype._fixDescriptor = function (descriptor, parentDescriptor, parentDataSource, rootParams) {
                // TODO: Move this to the server
                // Create the correct DOM element based on the type of control
                switch (descriptor.TypeName) {
                    case "HyperLink":
                    case "AnchorButton":
                        descriptor.TagName = "a";
                        break;
                    case "MenuItem":
                    case "MenuItemButton":
                    case "CommandButton":
                    case "DropDialogButton":
                    case "ToggleButton":
                    case "Button":
                        descriptor.TagName = "button";
                        break;
                    case "InputLabel":
                    case "MultilineInputLabel":
                    case "RealLabel":
                    case "IntegerLabel":
                    case "Int64Label":
                    case "DateLabel":
                    case "DateTimeLabel":
                    case "TimeLabel":
                    case "Label":
                        if (rootParams && rootParams._name === "SysBoxForm_form" && descriptor.ValueProperties && descriptor.ValueProperties.Style === "titleField") {
                            descriptor.TagName = "h1";
                        }
                        else {
                            descriptor.TagName = "span";
                        }
                        break;
                    case "Grid":
                    case "ListView":
                        if (parentDataSource && parentDataSource.getValue("UseReactGrid")) {
                            descriptor.TypeName = "ReactList";
                        }
                        else {
                            descriptor.TypeName = "List";
                        }
                        break;
                    case "ActionGroup":
                        // TODO: Support classifiers on server
                        var name_9 = descriptor.Name;
                        if (name_9 && name_9.substr(0, 36) === "SystemDefinedButtonsButtonGroup_Form") {
                            descriptor.Classifiers = ["actionGroup-right"];
                        }
                        break;
                    case "CheckBox":
                        descriptor.TagName = "label";
                        break;
                    case "Tile":
                        descriptor.TagName = "div";
                        if (descriptor.ValueProperties) {
                            if (descriptor.ValueProperties.TileType === $dyn.ui.TileType.count) {
                                descriptor.TypeName = "CountTile";
                            }
                            else if (descriptor.ValueProperties.TileType === $dyn.ui.TileType.kpi) {
                                descriptor.TypeName = "KPITile";
                                if (descriptor.ValueProperties.Url) {
                                    descriptor.TagName = "a";
                                }
                            }
                            else if (descriptor.ValueProperties.TileType === $dyn.ui.TileType.link) {
                                descriptor.TypeName = "LinkTile";
                                descriptor.TagName = "a";
                            }
                        }
                }
                if (!descriptor.TagName) {
                    descriptor.TagName = "div";
                }
                var styleProperty = this._propertyValue("Style", descriptor);
                if (styleProperty) {
                    if (descriptor.Classifiers && descriptor.Classifiers.indexOf(styleProperty) === -1) {
                        descriptor.Classifiers.push(styleProperty);
                    }
                    else {
                        descriptor.Classifiers = [styleProperty];
                    }
                }
                var extendedStyleProperty = this._propertyValue("ExtendedStyle", descriptor);
                if (extendedStyleProperty) {
                    if (descriptor.Classifiers && descriptor.Classifiers.indexOf(extendedStyleProperty) === -1) {
                        descriptor.Classifiers.push(extendedStyleProperty);
                    }
                    else {
                        descriptor.Classifiers = [extendedStyleProperty];
                    }
                }
                var specialProperty = this._propertyValue("PrimaryModelName", descriptor);
                if (specialProperty) {
                    descriptor.DataSourceName = specialProperty;
                    delete descriptor.ValueProperties.PrimaryModelName;
                }
                specialProperty = this._propertyValue("ListItemViewModelDescriptor", descriptor);
                if (specialProperty) {
                    descriptor.ChildViewModels = specialProperty.ChildViewModels;
                    delete descriptor.ValueProperties.ListItemViewModelDescriptor;
                }
                var personalizationCommand = this._getCommand("PersistPersonalization", descriptor);
                if (personalizationCommand) {
                    personalizationCommand.ValueTypeName = "PersistPersonalization";
                }
            };
            InteractionHandler.prototype._createControl = function (rootControlParams, descriptor, parentDescriptor, parentDataSource) {
                this._createControlTask && this._createControlTask.start(descriptor.TypeName);
                this._createControlByNameTask && this._createControlByNameTask.start(descriptor.Name + "-" + descriptor.TypeName);
                var controlParams = {};
                var element = document.createElement(descriptor.TagName);
                controlParams._element = element;
                this._applyProperties(rootControlParams, controlParams, descriptor, parentDataSource, parentDescriptor);
                element.dynOptions = controlParams;
                if (rootControlParams._element) {
                    element.setAttribute("data-dyn-controlname", controlParams._name);
                }
                else {
                    element.setAttribute("id", "form_" + controlParams._serverId);
                    element.setAttribute("data-dyn-formid", controlParams._serverId);
                }
                if (controlParams._resource) {
                    // Ideally the form should be tracking the resources needed to avoid redundant resource specification.
                    $dyn.resources._addUnresolvedElement(element, controlParams._resource, rootControlParams._element);
                }
                element.setAttribute("data-dyn-role", controlParams._typeName);
                rootControlParams._allControls[descriptor.Name.toLowerCase()] = controlParams;
                if (descriptor.Classifiers) {
                    for (var i = 0, len = descriptor.Classifiers.length; i < len; i++) {
                        try {
                            element.classList.add(descriptor.Classifiers[i]);
                        }
                        catch (error) {
                            // no-error
                        }
                    }
                }
                controlParams.TypeName = descriptor.TypeName;
                this._createControlByNameTask && this._createControlByNameTask.stop(descriptor.Name + "-" + descriptor.TypeName);
                this._createControlTask && this._createControlTask.stop(descriptor.TypeName);
                return controlParams;
            };
            /**
             * Handle command callback interactions
             * @param interactions CommandCallback interactions to process
             */
            InteractionHandler.prototype._handleCommandCallbacks = function (interactions) {
                for (var i = 0, len = interactions.length; i < len; i++) {
                    var interaction = interactions[i];
                    $dyn.log.server && $dyn.log.server("ServerForm: Handling callback interaction: %o", interaction);
                    var callback = void 0;
                    var functionId = interaction.callback._functionId;
                    if (typeof functionId !== "undefined") {
                        callback = $dyn.serverForm.idToWindowFunction[functionId];
                        $dyn.serverForm.idToWindowFunction[functionId] = null;
                    }
                    else {
                        callback = interaction.callback;
                    }
                    if (!callback) {
                        $dyn.logError("ServerForm: Callback was undefined on the interaction or already removed from the map");
                    }
                    var callbackResult = void 0;
                    // Interaction channel may send the result value of the execution
                    if (interaction.Result) {
                        // TODO: ValueFactory
                        // callbackResult = ValueFactory.GetValue(interaction.Result);
                        callbackResult = interaction.Result;
                    }
                    var serializer = void 0;
                    if (callbackResult) {
                        serializer = $dyn.serverForm.serializers[callbackResult.ValueType];
                    }
                    if (!serializer) {
                        serializer = $dyn.serverForm.serializers.default;
                    }
                    if (callbackResult && callbackResult.Value) {
                        callback(serializer.deserialize(callbackResult.Value));
                    }
                    else {
                        callback();
                    }
                }
                if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName) && $dyn.reactGrid.appliedVirtualizedProperty) {
                    $dyn.reactGrid.appliedVirtualizedProperty = false;
                    $dyn.serverForm.UpdateModelManager.raiseChanges();
                }
            };
            return InteractionHandler;
        }());
        serverForm.InteractionHandler = InteractionHandler;
        serverForm.interactionHandler = new InteractionHandler();
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=InteractionHandler.js.map
